
let getPickers = () => {
	return import(/* webpackChunkName: "seriousIncident" */ './SeriousIncident').then((module) => {
		return module;
	});
}

export default {
	reload: (rootElement?: HTMLElement) => {
		var nodes = (rootElement || document).querySelectorAll(".qd-react-serious-incident-control");
		if (nodes.length != 0) {
			getPickers().then(module => {
				for (let i = 0; i < nodes.length; i++) {
					let node = nodes[i] as HTMLElement;
					
					module.renderControl(node);
				}
			})
			.catch(error => console.error(error));
		}
	}
} 